import { render, staticRenderFns } from "./SidebarBasePanel.vue?vue&type=template&id=2e7b9cd6"
import script from "./SidebarBasePanel.vue?vue&type=script&lang=js"
export * from "./SidebarBasePanel.vue?vue&type=script&lang=js"
import style0 from "./SidebarBasePanel.vue?vue&type=style&index=0&id=2e7b9cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports